import React from 'react';

function AffichageEssais({ essais }) {
  return (
    <p>Essais restants : {essais}</p>
  );
}

export default AffichageEssais;